import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import CreateVehicle from "../pages/Vehicle/CreateVehicle";
//@ts-ignore
import { PermissionRequired, AccessControl } from "@careinfo/permission-required";
import VehicleList from "../pages/Vehicle/VehicleList";
import EditVehicle from "../pages/Vehicle/EditVehicle";
import CreateVehicleCategory from "../pages/VehicleCategory/CreateVehicleCategory";
import VehicleCategoryList from "../pages/VehicleCategory/VehicleCategoryList";
import EditVehicleCategory from "../pages/VehicleCategory/EditVehicleCategory";
import CreateVehicleType from "../pages/VehicleType/CreateVehicle";
import VehicleTypeList from "../pages/VehicleType/VehicleList";
import EditVehicleType from "../pages/VehicleType/EditVehicle";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
        <Route path={"/"} element={
          <AccessControl children={<VehicleCategoryList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/vehicle-category"} element={
          <AccessControl children={<VehicleCategoryList />}
            allowedPermissions={["can_view_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/create"} element={
          <AccessControl children={<CreateVehicleCategory />}
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
        <Route path={"/edit/:id"} element={
          <AccessControl children={<EditVehicleCategory />}
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={<PermissionRequired />}
          />
        } />
       
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;